import { taxaDoRecebimento } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { reais } from "@/lib/dinheiro";

/** "Taxa do cartão (3,5%): R$ 10,50 · líquido R$ 289,50" antes de confirmar o recebimento. */
export function PreviaDaTaxa({ valorCents, forma }: { valorCents: number; forma: string | null }) {
  const config = trpc.financeiro.configFinanceira.ler.useQuery().data;
  if (!config || valorCents <= 0) return null;
  const taxa = taxaDoRecebimento(valorCents, forma, config);
  if (!taxa) return null;
  const rotulo =
    forma === "CARTAO" ? `Taxa do cartão (${((config.taxaDoCartaoBps ?? 0) / 100).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%)` : "Tarifa do boleto";
  return (
    <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">
      {rotulo}: <span className="tabular-nums">{reais(taxa)}</span> · líquido <span className="tabular-nums">{reais(valorCents - taxa)}</span>. A taxa entra sozinha em Lançamentos.
    </p>
  );
}
